import { faCommentDots, faEnvelope, faPhone, faGlobe, faBookOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Wrapper, Article, Content } from './styles'
import { isPaying } from '@meniudigital/shared'
import { usersSelector } from 'src/state/selectors'
import { useSelector } from 'react-redux'

const feedbackFormBaseUrl =
  'https://docs.google.com/forms/d/e/1FAIpQLSdHUHACNw9KwkPjzinvVSZewFWGU_IxSpF3r6AZXk3N0APAIw/viewform?usp=pp_url&entry.441883612='

export default function Contact() {
  const { user } = useSelector(usersSelector)

  const openFeedbackForm = () => {
    window.open(`${feedbackFormBaseUrl}${encodeURIComponent(user?.username || '')}`, '_blank', 'noopener,noreferrer')
  }

  const copyEmailToClipboard = async () => {
    try {
      await navigator.clipboard.writeText('contact@meniudigital.ro')
      window.showConfirm({ text: 'E-mail copiat în clipboard!' })
    } catch (e) {
      window.showConfirm({ text: 'Nu s-a putut copia e-mailul', type: 'error' })
    }
  }

  const openMessenger = () => {
    window.open('https://www.facebook.com/meniudigital.ro', '_blank', 'noopener,noreferrer')
  }

  return (
    <Wrapper>
      <Article>
        <h3 className="page-question">Dorești să iei legătura cu noi?</h3>

        <Content>
          <div className="contact-methods">
            <div className="contact-panel featured">
              <div className="panel-head">
                <div className="icon-tile">
                  <FontAwesomeIcon icon={faCommentDots} />
                </div>
                <h3 className="title">Oferă-ne un Feedback</h3>
              </div>
              <p className="description">
                Ai idei despre cum ar putea fi îmbunătățită platforma? Scrie-ne aici!
              </p>
              <div className="cta" onClick={openFeedbackForm}>
                <span>Deschide formularul</span>
              </div>
            </div>

            <div className="contact-panel email">
              <div className="panel-head">
                <div className="icon-tile">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <h3 className="title">E-mail</h3>
              </div>
              <p className="description">Pentru întrebări sau solicitări comerciale</p>
              <a href="mailto:contact@meniudigital.ro" className="value-text">
                contact@meniudigital.ro
              </a>
              <div className="cta" onClick={copyEmailToClipboard}>
                <span>Copiază în clipboard</span>
              </div>
            </div>

            <div className="contact-panel messenger">
              <div className="panel-head">
                <div className="icon-tile">
                  <svg viewBox="0 0 320 512" role="img" aria-label="Facebook" style={{ height: '1em', fill: 'currentColor' }}>
                    <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
                  </svg>
                </div>
                <h3 className="title">Facebook Messenger</h3>
              </div>
              <p className="description">Chat direct prin pagina noastră de Facebook</p>
              <a href="https://www.facebook.com/meniudigital.ro" target="_blank" rel="noopener noreferrer" className="value-text">
                @meniudigital.ro
              </a>
              <div className="cta" onClick={openMessenger}>
                <span>Deschide Facebook</span>
              </div>
            </div>

            {isPaying(user) && (
              <div className="contact-panel phone">
                <div className="panel-head">
                  <div className="icon-tile">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <h3 className="title">Telefon</h3>
                </div>
                <p className="description">Pentru urgențe de ordin tehnic</p>
                <a href="tel:+40774566954" className="value-text">
                  +40774566954
                </a>
                <div className="schedule">Orar: L-V 10:00-18:00</div>
                <a href="tel:+40774566954" className="cta">
                  <span>Apelează</span>
                </a>
              </div>
            )}

            {user && (
              <div className="contact-panel onboarding" onClick={() => window.openOnboardingPackageModal()}>
                <div className="panel-head">
                  <div className="icon-tile">
                    <FontAwesomeIcon icon={faBookOpen} />
                  </div>
                  <h3 className="title">Pachet Digitalizare</h3>
                </div>
                <p className="description">
                  Ne ocupăm de importul produselor și de configurarea inițială a contului tău.
                </p>
                <div className="cta">
                  <span>Află mai multe</span>
                </div>
              </div>
            )}
          </div>

          <a className="main-site-link" href="https://www.meniudigital.ro" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faGlobe} />
            <span>www.meniudigital.ro</span>
          </a>
        </Content>
      </Article>
    </Wrapper>
  )
}
